import check from "./check.svg";
import gradient from "./gradient.png";
import curve from "./hero/curve.png";
import lines from "./pricing/lines.svg";
import stars from "./pricing/stars.svg";

import discordBlack from "./socials/discord.svg";
import facebook from "./socials/facebook.svg";
import instagram from "./socials/instagram.svg";
import telegram from "./socials/telegram.svg";
import youtube from "./socials/youtube.svg";

import trampoline from "./benefits/trampoline.svg";
import bowling from "./benefits/bowling.svg";
import arcade from "./benefits/arcade.svg";
import vr from "./benefits/vr.svg";
import food from "./benefits/food.svg";
import playground from "./benefits/playground.svg";

import WhatsappFooter from "./socials/WhatsappFooter.svg"
import WhatsappHeader from "./socials/WhatsappHeader.svg"



export {

  youtube,
  WhatsappHeader,
  WhatsappFooter,
  playground,
  food,
  bowling,
  arcade,
  vr,
  trampoline,
  check,
  gradient,
  curve,
  lines,
  stars,
  discordBlack,
  facebook,
  instagram,
  telegram,
};
